import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private tokenSubject = new BehaviorSubject<string | null>(null);

    constructor(private cookieService: CookieService) {
        this.initializeToken();
    }

    private initializeToken() {
        const token = this.cookieService.get('access_token');
        if (token) {
            this.tokenSubject.next(token);
        }
    }

    getToken(): string | null {
        return this.tokenSubject.value;
    }

    setToken(token: string) {
        this.tokenSubject.next(token);
        this.cookieService.set('access_token', token, 1, '/', undefined, false, 'Lax');
    }

    clearToken() {
        this.tokenSubject.next(null);
        this.cookieService.delete('access_token');
    }

    isLoggedIn(): boolean {
        return !!this.tokenSubject.value;
    }
}
